// SPDX-License-Identifier: AGPL-3.0-or-later
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import type {UserPartial} from '@app/vendor/schema/domains/user/UserResponseSchemas';

interface GuildBanPayload {
	guild_id: string;
	user: UserPartial;
}
export function handleGuildBan(_data: GuildBanPayload, _context: GatewayHandlerContext): void {}
